import styled from "styled-components";
import { off_black, white } from "../constants/styles";

export const BlackTheme = styled.div`
  background-color: ${off_black};
  color: ${white};
`;

export const LightGreyTheme = styled.div`
  background-color: #fafafa;
  color: #333333;
`;

export const FooterTheme = styled.div`
  background-color: #2e2e2e;
  color: ${white};
`;
